import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import success from '../assets/tick-circle.png'
import failure from '../assets/close-circle.png'
import pending from '../assets/uiw_time.png'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux';

function PaymentSuccess() {
    const navigate = useNavigate()
  const id = localStorage.getItem("payment_id");
  const data = useSelector((state) => state.AdminData.admin)
  const [paymentData, setPaymentData] = useState({});
  const [callChargeApi, setCallChargeApi] = useState(true);
  const pageNavigate = localStorage.getItem("pageNavigate")
  


  const removeService = async () => {
    try {
        const response = axiosInstance.delete(`service-delete/${id}`)
        console.log(response)
        if(response.status === 200){
            console.log(response)
        }
    } catch (error) {
        console.log(error)
    }
  }

  const resetTenancyAgreement = async () => {
    try {
        const response = axiosInstance.delete(`reset-tenancy-agreement/${id}`)
        console.log(response)
        if(response.status === 200){
            console.log(response)
        }
    } catch (error) {
        console.log(error)
    }
  }

  const resetApplicationPayment = async () => {
    try {
        const response = axiosInstance.delete(`application-payment-reset/${data.id}`)
        console.log(response)
        if(response.status === 200){
            console.log(response)
        }
    } catch (error) {
        console.log(error)
    }
  }


  const sendMail = async (to, subject, text) => {
    try {
      const response = await axiosInstance.post(`send-mail`, {
        email : to,
        subject,
        text
      })
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }


  const checkStatus = async (chargeToken) => {
    console.log(chargeToken)
    if(chargeToken === undefined || chargeToken === null){
      navigate('/')
    }
    try {
      const response = await axiosInstance.get(`charge-status/${chargeToken}`);
      console.log(response.data);
      setPaymentData(response.data.data);

      const status = response.data.data.status;
      console.log(status)
      if (status === "successful"){
        localStorage.removeItem("payment_id")
        setCallChargeApi(false);
        const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
        let subject = "";
        let text = "";
        let adminSubject = "";
        let adminText = "";
      
        if (pageNavigate === "service") {
          subject = "Service Booked Successfully";
          text = `Hi ${data.name},\n\nYour service has been booked successfully. Thank you for choosing our platform. We will contact you shortly with further details.\n\nBest regards,\nThe Vinga Team`;
        
          adminSubject = "New Service Booking from Vinga";
          adminText = `A new service has been booked by ${data.userName}. Please review the booking in the admin dashboard.`;
        } else if (pageNavigate === "application") {
          subject = "Application Received Successfully";
          text = `Hi ${data.name},\n\nYour application has been received successfully. Our team will review the details and reach out to you if needed.\n\nThank you,\nThe Vinga Team`;
        
          adminSubject = "New Application Submitted from Vinga";
          adminText = `An application was submitted by ${data.userName}. Please check the admin portal for details.`;
        } else if (pageNavigate === "tenancy") {
          subject = "Tenancy Agreement Received Successfully";
          text = `Hi ${data.name},\n\nWe've received your tenancy agreement. Our team will review the submission and provide further instructions soon.\n\nThank you,\nThe Vinga Team`;

          adminSubject = "New Tenancy Agreement Submission from Vinga";
          adminText = `A tenancy agreement has been submitted by ${data.userName}. Please review it in the admin system.`;
        }
      
        Promise.all([
          sendMail(data.userName, subject, text),
          sendMail(adminEmail, adminSubject, adminText)
        ])
        .then(() => {
          console.log("Both emails sent successfully.");
        })
        .catch((error) => {
          console.error("Error sending one or both emails:", error);
        });
        
        }  
        else if(status === "failed") {
        setCallChargeApi(false);
        let subject = "";
        let text = "";

        let adminSubject = "";
        let adminText = "";
        const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
      
        if (pageNavigate === "service") {
          removeService();
          subject = "Service Booking Failed";
          text = `Hi ${data.name},\n\nUnfortunately, your service booking payment has failed. Please try again or contact support for assistance.\n\nRegards,\nThe Vinga Team`;
        
          adminSubject = "Service Booking Payment Failed from Vinga";
          adminText = `Payment failed for service booking by ${data.userName}. Please follow up if needed.`;
        
        } else if (pageNavigate === "application") {
          resetApplicationPayment();
          subject = "Application Submission Failed";
          text = `Hi ${data.name},\n\nIt seems your application payment failed. Please retry the payment process to complete your application.\n\nRegards,\nThe Vinga Team`;
        
          adminSubject = "Application Payment Failed from Vinga";
          adminText = `Payment failed for application by ${data.userName}.`;
        } else if (pageNavigate === "tenancy") {
          resetTenancyAgreement();
          subject = "Tenancy Agreement Payment Failed";
          text = `Hi ${data.name},\n\nYour tenancy agreement submission could not be completed due to a payment failure. Kindly try again.\n\nRegards,\nThe Vinga Team`;

          adminSubject = "Tenancy Payment Failed from Vinga";
          adminText = `Payment failed for tenancy agreement by ${data.userName}.`;
        }
      
        Promise.all([
          sendMail(data.userName, subject, text),
          sendMail(adminEmail, adminSubject, adminText)
        ])
        .then(() => {
          console.log("Both emails sent successfully.");
        })
        .catch((error) => {
          console.error("Error sending one or both emails:", error);
        });
      }
    } catch (error) {
      console.error('Error fetching charge status:', error);
    }
  };


  

  useEffect(() => {
    let intervalId;

    if (id && callChargeApi) {
      // Call once immediately
      checkStatus(id);

      // Then poll every 5 seconds
      intervalId = setInterval(() => {
        checkStatus(id);
      }, 5000);
    }

   

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [id, callChargeApi]);

  useEffect(() => {
    if(!id){
      navigate("/")
    }
  }, [])

  const getAmount = (amount) => {
      if(amount){
        return (amount/100)
      }
      return '-'
  }

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      {/* <h2>Payment Status</h2>
      <p>Status: <strong>{paymentData?.status || "Checking..."}</strong></p> */}

      <Box>

      </Box>
      {paymentData?.status === "successful" && (
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', height : 'auto'}}>
              <Box sx={{ borderRadius : '20px',width : {xs : '95%', md : '60%',lg : '40%'}, boxShadow: "0px 4px 13px 0px #00000040", padding : {xs : '15px', md : '30px'}}}>
                    <Box sx={{display : 'flex', justifyContent :'center'}}>
                    <Box sx={{width : '150px', height : '150px', backgroundColor : '#D1FADF80', borderRadius : '100%', display : 'flex', justifyContent :'center', alignItems : 'center'}}>
                        <Box sx={{width : '80px'}} component={'img'} src={success}></Box>
                    </Box>
                    </Box>
                    <Box sx={{mt : 2}}>
                      <Typography sx={{fontSize : {xs : '20px', md : '36px'}, color : '#737373'}}>Payment was successful</Typography>
                    </Box>
                    <Box sx={{mt : 2}}>
                      <Typography sx={{fontSize : {xs : '24px', md : '36px'}, fontWeight : 700}}>{`S$ ${getAmount(paymentData?.amount)}`}</Typography>
                    </Box>
                    <Box sx={{mt : 3}}>
                        <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Bank Name</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{paymentData?.card?.bank || '-'}</Typography>
                        </Box>
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Payment Time</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{dayjs(paymentData?.paid_at).format("DD/MM/YYYY hh:mm A") || '-'}</Typography>
                        </Box>
                        {/* <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                              <Typography sx={{fontSize : '20px', color : '#737373'}}>Payment Method</Typography>
                              <Typography sx={{fontSize : '20px'}}>{paymentData?.card?.bank || '-'}</Typography>
                        </Box> */}
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Applicant Name</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{paymentData?.card?.name || '-'}</Typography>
                        </Box>
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Amount</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{`S$ ${getAmount(paymentData?.amount)}`}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{mt : 1}}>
                    <Button onClick={() => navigate('/account')} sx={{mt : 2, width : '100%', fontSize : {xs : '14px', md : '24px'}, fontWeight : 700}} variant='contained'>Go to Account</Button>
                    </Box>
              </Box>
          </Box>
      )}
      {paymentData?.status === "failed" && (
         <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', height : 'auto'}}>
         <Box sx={{ borderRadius : '20px',width :  {xs : '95%', md : '60%',lg : '40%'}, boxShadow: "0px 4px 13px 0px #00000040", padding : {xs : '15px', md : '30px'}}}>
               <Box sx={{display : 'flex', justifyContent :'center'}}>
               <Box sx={{width : '150px', height : '150px', backgroundColor : '#F6D2D2', borderRadius : '100%', display : 'flex', justifyContent :'center', alignItems : 'center'}}>
                   <Box sx={{width : '80px'}} component={'img'} src={failure}></Box>
               </Box>
               </Box>
               <Box sx={{mt : 2}}>
                 <Typography sx={{fontSize : {xs : '20px', md : '36px'}, color : '#737373'}}>Payment was Failed</Typography>
               </Box>
               <Box sx={{mt : 2}}>
                 <Typography sx={{fontSize : {xs : '24px', md : '36px'}, fontWeight : 700}}>{`S$ ${getAmount(paymentData?.amount)}`}</Typography>
               </Box>
               <Box sx={{mt : 3}}>
                        <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Bank Name</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{paymentData?.card?.bank || '-'}</Typography>
                        </Box>
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Payment Time</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{dayjs(paymentData?.paid_at).format("DD/MM/YYYY hh:mm A") || '-'}</Typography>
                        </Box>
                        {/* <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                              <Typography sx={{fontSize : '20px', color : '#737373'}}>Payment Method</Typography>
                              <Typography sx={{fontSize : '20px'}}>{paymentData?.card?.bank || '-'}</Typography>
                        </Box> */}
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Applicant Name</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{paymentData?.card?.name || '-'}</Typography>
                        </Box>
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Amount</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{`S$ ${getAmount(paymentData?.amount)}`}</Typography>
                        </Box>
                    </Box>
               <Box sx={{mt : 1}}>
               <Button onClick={() => navigate('/')} sx={{mt : 2, width : '100%', fontSize : '24px', fontWeight : 700}} variant='contained'>Go to Homepage</Button>
               </Box>
         </Box>
     </Box>
      )}

      {paymentData?.status === "pending" && (
         <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', height : 'auto'}}>
         <Box sx={{ borderRadius : '20px',width : {sm : '90%', lg : '40%'}, boxShadow: "0px 4px 13px 0px #00000040", padding : '30px'}}>
               <Box sx={{display : 'flex', justifyContent :'center'}}>
               <Box sx={{width : '150px', height : '150px', backgroundColor : '#FEF3C6', borderRadius : '100%', display : 'flex', justifyContent :'center', alignItems : 'center'}}>
                   <Box sx={{width : '80px'}} component={'img'} src={pending}></Box>
               </Box>
               </Box>
               <Box sx={{mt : 2}}>
                 <Typography sx={{fontSize : '36px', color : '#737373'}}>Payment was Pending</Typography>
               </Box>
               <Box sx={{mt : 2}}>
                 <Typography sx={{fontSize : '36px', fontWeight : 700}}>{`S$ ${getAmount(paymentData?.amount)}`}</Typography>
               </Box>
               <Box sx={{mt : 3}}>
                        <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Bank Name</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{paymentData?.card?.bank || '-'}</Typography>
                        </Box>
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Payment Time</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{dayjs(paymentData?.paid_at).format("DD/MM/YYYY hh:mm A") || '-'}</Typography>
                        </Box>
                        {/* <Box sx={{display : 'flex', justifyContent : 'space-between'}}>
                              <Typography sx={{fontSize : '20px', color : '#737373'}}>Payment Method</Typography>
                              <Typography sx={{fontSize : '20px'}}>{paymentData?.card?.bank || '-'}</Typography>
                        </Box> */}
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Applicant Name</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{paymentData?.card?.name || '-'}</Typography>
                        </Box>
                        <Box sx={{display : 'flex', justifyContent : 'space-between', mt : 2}}>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}, color : '#737373', width : '50%', textAlign : 'start'}}>Amount</Typography>
                              <Typography sx={{fontSize : {xs : '10px', sm : '20px'}}}>{`S$ ${getAmount(paymentData?.amount)}`}</Typography>
                        </Box>
                    </Box>
               {/* <Box sx={{mt : 1}}>
               <Button onClick={() => navigate('/account')} sx={{mt : 2, width : '100%', fontSize : '24px', fontWeight : 700}} variant='contained'>Go to Account</Button>
               </Box> */}
         </Box>
     </Box>
      )}
      
    </div>
  );
}

export default PaymentSuccess;
